import React from 'react';
import '../Newsletter/Newsletter.css';
import { FaArrowRight } from 'react-icons/fa';

const Newsletter = () => {
  return (
    <div className="newsletter-section-n">
      <div className="overlay-n">
        <div className="newsletter-content-n">
          <p className="newsletter-subheading-n">STAY UPDATED</p>
          <h1 className="newsletter-heading-n">Subscribe to Our Newsletter</h1>
          <div className="newsletter-input-n">
            <input type="email" placeholder="Enter your email" />
            <button><FaArrowRight /></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
